import React from 'react';
import Outlet from './Outlet';

export default function PDU({pdu, dcId, cabId, api, user}) {

  return <div className="PDU col-sm-12 col-md-6 list-group">
    <div className="PDU-title list-group-item">{pdu.url}</div>
    {pdu.outlets.map(o => <Outlet key={"outlet_" + o.id} outlet={o} pduName={pdu.url} pduId={pdu.id} dcId={dcId} cabId={cabId} api={api} user={user}></Outlet>)}
  </div>
}
